import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import type { BaseNode } from '../../hooks/useNearbyBaseNodes';

/**
 * Selector to get base nodes that match the serial numbers from sector results.
 * Returns a filtered array containing only the base nodes whose serial numbers
 * appear in the sectorResults, or null if no matches are found.
 */
export const selectSectorNearbyBNs = createSelector(
  [
    (state: RootState) => state.servicePredictor.sectorResults,
    (state: RootState) => state.servicePredictor.baseNodeList,
  ],
  (sectorResults, baseNodeList): BaseNode[] | null => {
    if (!sectorResults || !baseNodeList || baseNodeList.length === 0) {
      return null;
    }

    const sectorSerialNumbers = new Set<string>();

    if (sectorResults.sector_list && Array.isArray(sectorResults.sector_list)) {
      sectorResults.sector_list.forEach((sector: any) => {
        if (sector.bn?.serial) {
          sectorSerialNumbers.add(sector.bn.serial);
        }
      });
    } else if (sectorResults.bn?.serial) {
      sectorSerialNumbers.add(sectorResults.bn.serial);
    }

    if (sectorSerialNumbers.size === 0) {
      return null;
    }

    const matchedBNs = baseNodeList.filter(
      (bn: BaseNode) => bn.serial && sectorSerialNumbers.has(bn.serial)
    );

    if (matchedBNs.length === 0) {
      return null;
    }

    return matchedBNs;
  }
);
